// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productPriceStyles } from "@awc/Overrides/Components/ProductPrice";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { css } from "styled-components";

productPriceStyles.priceWrapper = {
    css: css`
        line-height: ${fontConfig.lineHeight.singleLineRegular};
    `,
};

productPriceStyles.price = {
    ...productPriceStyles.price,
    priceText: {
        size: fontConfig.fontSize.regular,
        weight: fontConfig.weight.bold,
        lineHeight: fontConfig.lineHeight.singleLineRegular,
    },
};

productPriceStyles.quoteMessage = {
    text: {
        size: fontConfig.fontSize.regular,
        weight: fontConfig.weight.bold,
        lineHeight: fontConfig.lineHeight.singleLineRegular,
    },
};

productPriceStyles.quoteMessageWrapper = {
    css: css`
        display: flex;
    `,
};

productPriceStyles.unitOfMeasure = {
    unitOfMeasureText: {
        size: fontConfig.fontSize.regular,
        weight: fontConfig.weight.regular,
        lineHeight: fontConfig.lineHeight.singleLineRegular,
    },
};
